import {PersonEntity, PersonSelectorProps, personsSelector, useGetAllPersonsQuery} from "@ots-frontend/ots-data";
import {BasePersonSelect, BasePersonSelectProps} from "./BasePersonSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type PersonSelectProps = Omit<BasePersonSelectProps, "entities" | "loading"> & {
  selector?: PersonSelectorProps
}

export const PersonSelect = (props: PersonSelectProps) => {
  const {selector, ...rest} = props;

  const selectPersons = useMemo(() => {
    return personsSelector();
  }, []);

  const {persons, isLoading} = useGetAllPersonsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      persons: selectPersons(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BasePersonSelect entities={persons} loading={isLoading} {...rest} />;
};

export interface PersonSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: PersonSelectProps,
  onSubmit?: (persons: PersonEntity[] | undefined) => void
}

export const PersonSelectModal = (props: PersonSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedPersons, setSelectedPersons] = useState<PersonEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <PersonSelect
          {...select}
          onEntityChange={e => setSelectedPersons(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedPersons);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
